var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.validBlocks.length > 0
    ? _c(
        "div",
        {
          staticClass: "editorial-sets",
          class: [_vm.schema.settings.bgColor],
          style: {
            "padding-top": _vm.schema.settings.marginTop + "px",
            "padding-bottom": _vm.schema.settings.marginBottom + "px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "container" },
            [
              _c(
                "v-arrow-button",
                {
                  staticClass:
                    "editorial-sets__arrow editorial-sets__arrow--left u-hidden-mobile-only u-hidden-tablet-only",
                  attrs: {
                    disabled: _vm.mainPrevDisabled ? "disabled" : false,
                    primary: true
                  },
                  on: { click: _vm.prevSlideMain }
                },
                [_c("icon", { attrs: { name: "arrow-left" } })],
                1
              ),
              _c(
                "swiper",
                {
                  ref: "mainSwiper",
                  staticClass: "editorial-sets__main",
                  attrs: { options: _vm.mainSwiperOptions }
                },
                _vm._l(_vm.validBlocks, function(block, index) {
                  return _c(
                    "swiperSlide",
                    {
                      key: block.id,
                      staticClass: "editorial-sets__main-slide"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "editorial-sets__header" },
                        [
                          _c(
                            "div",
                            { staticClass: "editorial-sets__header-text" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "editorial-sets__title h3",
                                  class: [_vm.schema.settings.textColorClass]
                                },
                                [_vm._v(_vm._s(block.settings.title))]
                              ),
                              _c(
                                "v-link",
                                {
                                  staticClass:
                                    "editorial-sets__link u-hidden-tablet-up",
                                  class: [_vm.schema.settings.textColorClass],
                                  attrs: {
                                    primary: "",
                                    href: block.settings.linkURL
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      block.settings.linkText || "Shop the Set"
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-link",
                            {
                              staticClass:
                                "editorial-sets__link u-hidden-mobile-only",
                              class: [_vm.schema.settings.textColorClass],
                              attrs: {
                                primary: "",
                                href: block.settings.linkURL
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  block.settings.linkText || "Shop the Set"
                                )
                              )
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "editorial-sets__main-controls",
                              class: { "u-hidden": _vm.validBlocks.length <= 1 }
                            },
                            [
                              _c("icon", {
                                staticClass: "editorial-sets__main-arrow",
                                attrs: {
                                  name: "chevron-left",
                                  size: "12px",
                                  fillClass: _vm.fillColor
                                },
                                on: { click: _vm.prevSlideMain }
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "editorial-sets__slide-count",
                                  class: [_vm.schema.settings.textColorClass]
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      "" +
                                        (index + 1) +
                                        (_vm.$mq === "mobile" ? "/" : " OF ") +
                                        _vm.validBlocks.length
                                    )
                                  )
                                ]
                              ),
                              _c("icon", {
                                staticClass: "editorial-sets__main-arrow",
                                attrs: {
                                  name: "chevron-right",
                                  size: "12px",
                                  fillClass: _vm.fillColor
                                },
                                on: { click: _vm.nextSlideMain }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "editorial-sets__content bg-white" },
                        [
                          _c("div", {
                            staticClass: "editorial-sets__image",
                            style: {
                              "background-image":
                                "url(" + block.settings.image + ")"
                            }
                          }),
                          _vm.productData[index]
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "editorial-sets__product-container"
                                },
                                [
                                  _c(
                                    "swiper",
                                    {
                                      ref: "productSwiper",
                                      refInFor: true,
                                      staticClass: "editorial-sets__product",
                                      class: {
                                        "swiper-no-swiping":
                                          _vm.productData[index].length <= 1
                                      },
                                      attrs: {
                                        options: Object.assign(
                                          {},
                                          _vm.productSwiperOptions,
                                          {
                                            initialSlide: Math.floor(
                                              (_vm.productData[index].length -
                                                1) /
                                                2
                                            ),
                                            pagination: _vm.paginationSettings(
                                              ".editorial-sets__product-pagination",
                                              index
                                            )
                                          }
                                        )
                                      }
                                    },
                                    _vm._l(_vm.productData[index], function(
                                      product,
                                      subindex
                                    ) {
                                      return _c(
                                        "swiperSlide",
                                        {
                                          key: subindex,
                                          staticClass:
                                            "editorial-sets__product-slide"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "editorial-sets__product-image-wrapper"
                                            },
                                            [
                                              _c("img", {
                                                staticClass:
                                                  "editorial-sets__product-image",
                                                attrs: {
                                                  src: product.image,
                                                  alt: product.imageAlt
                                                }
                                              })
                                            ]
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "editorial-sets__product-content-container"
                                    },
                                    [
                                      _c("fade-transition", [
                                        _c(
                                          "div",
                                          {
                                            key: "" + _vm.currentProductKey,
                                            staticClass:
                                              "editorial-sets__product-content"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "h6-mobile h6-tablet h5-desktop-up editorial-sets__product-title"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentProduct.title
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "body-sm-mobile body-sm-tablet body-md-desktop-up editorial-sets__product-desc"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentProduct.desc
                                                  )
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-link",
                                              {
                                                staticClass:
                                                  "editorial-sets__product-link",
                                                attrs: {
                                                  primary: "",
                                                  href:
                                                    "/products/" +
                                                    _vm.currentProduct.handle
                                                }
                                              },
                                              [_vm._v("Buy Now")]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c("div", {
                                    staticClass:
                                      "editorial-sets__product-pagination",
                                    class: {
                                      "u-hidden":
                                        _vm.productData[index].length <= 1
                                    },
                                    attrs: { "data-pagination": index }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      )
                    ]
                  )
                }),
                1
              ),
              _c(
                "v-arrow-button",
                {
                  staticClass:
                    "editorial-sets__arrow editorial-sets__arrow--right u-hidden-mobile-only u-hidden-tablet-only",
                  attrs: {
                    disabled: _vm.mainNextDisabled ? "disabled" : false,
                    primary: true
                  },
                  on: { click: _vm.nextSlideMain }
                },
                [_c("icon", { attrs: { name: "arrow-right" } })],
                1
              )
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }